module.exports = __webpack_public_path__ + "assets/img/18.11e99db5.png";